import React from "react";
import { useSelector } from "react-redux";
import { IRootState } from "shared/reducer";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import UnauthorizedLayout from "components/UnauthorizedLayout";
import Layout from "components/Layout";

export default function SuspenseLoading() {
	const isAuthenticated = useSelector(
		(state: IRootState) => state.authentication.isAuthenticated
	);

	const inner = (
		<Grid container item xs justify="center">
			<CircularProgress color="secondary" size={64} />
		</Grid>
	);

	if (isAuthenticated) {
		return <Layout>{inner}</Layout>;
	} else {
		return <UnauthorizedLayout>{inner}</UnauthorizedLayout>;
	}
}
